"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BodyDestinationBase = void 0;
var tslib_1 = require("tslib");
var bookmark_end_element_destination_1 = require("../bookmark/bookmark-end-element-destination");
var bookmark_start_element_destination_1 = require("../bookmark/bookmark-start-element-destination");
var comment_end_element_destination_1 = require("../comments/comment-end-element-destination");
var comment_start_element_destination_1 = require("../comments/comment-start-element-destination");
var destination_1 = require("../destination");
var range_permission_end_element_destination_1 = require("../range-permission/range-permission-end-element-destination");
var range_permission_start_element_destination_1 = require("../range-permission/range-permission-start-element-destination");
var deleted_run_content_destination_1 = require("../runs/deleted-run-content-destination");
var inserted_run_content_destination_1 = require("../runs/inserted-run-content-destination");
var structured_document_destination_1 = require("../structured-document-destination");
var BodyDestinationBase = (function (_super) {
    tslib_1.__extends(BodyDestinationBase, _super);
    function BodyDestinationBase() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BodyDestinationBase.onBookmarkStart = function (data, _reader) {
        return new bookmark_start_element_destination_1.BookmarkStartElementDestination(data);
    };
    BodyDestinationBase.onBookmarkEnd = function (data, _reader) {
        return new bookmark_end_element_destination_1.BookmarkEndElementDestination(data);
    };
    BodyDestinationBase.onRangePermissionStart = function (data, _reader) {
        return new range_permission_start_element_destination_1.RangePermissionStartElementDestination(data);
    };
    BodyDestinationBase.onRangePermissionEnd = function (data, _reader) {
        return new range_permission_end_element_destination_1.RangePermissionEndElementDestination(data);
    };
    BodyDestinationBase.onCommentStart = function (data, _reader) {
        return new comment_start_element_destination_1.CommentStartElementDestination(data);
    };
    BodyDestinationBase.onCommentEnd = function (data, _reader) {
        return new comment_end_element_destination_1.CommentEndElementDestination(data);
    };
    BodyDestinationBase.onStructuredDocument = function (data, _reader) {
        return new structured_document_destination_1.StructuredDocumentDestination(data);
    };
    BodyDestinationBase.onCustomXml = function (data, _reader) {
        return new destination_1.CustomXmlDestination(data);
    };
    BodyDestinationBase.onDeleted = function (data, _reader) {
        return data.options.ignoreDeletedText ? new destination_1.EmptyDestination(data) : new deleted_run_content_destination_1.DeletedRunContentDestination(data);
    };
    BodyDestinationBase.onInserted = function (data, _reader) {
        return data.options.ignoreInsertedText ? new destination_1.EmptyDestination(data) : new inserted_run_content_destination_1.InsertedRunContentDestination(data);
    };
    return BodyDestinationBase;
}(destination_1.ElementDestination));
exports.BodyDestinationBase = BodyDestinationBase;
